module.exports = __webpack_public_path__ + "edd822634bb0370e3b65867c963978b2.pdf";